module.exports = __webpack_public_path__ + "img/bc65f11.jpg";